var React = require('react');

function UploadInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"id":"Path","d":"M11.552,6.117,6.418.251a.732.732,0,0,0-1.1,0L.182,6.117A.733.733,0,0,0,.733,7.333H3.667v9.533A.734.734,0,0,0,4.4,17.6H7.333a.734.734,0,0,0,.733-.733V7.333H11a.733.733,0,0,0,.551-1.216Z","transform":"translate(5.133)","fill":"#fff","key":0}),React.createElement("path",{"id":"Path-2","data-name":"Path","d":"M19.067,0V4.4H2.933V0H0V5.867A1.466,1.466,0,0,0,1.467,7.333H20.533A1.465,1.465,0,0,0,22,5.867V0Z","transform":"translate(0 16.133)","fill":"#fff","key":1})]);
}

UploadInline.defaultProps = {"id":"upload","width":"22","height":"23.467","viewBox":"0 0 22 23.467"};

module.exports = UploadInline;

UploadInline.default = UploadInline;
